import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, PlantProvider, useAuth } from "@/lib/context";
import Login from "@/pages/Login";
import Shell from "@/components/Shell";
import CommandCentre from "@/pages/CommandCentre";
import Furnace from "@/pages/Furnace";
import Charge from "@/pages/Charge";
import Operations from "@/pages/Operations";
import Air from "@/pages/Air";
import Utilities from "@/pages/Utilities";
import YieldScreen from "@/pages/Yield";
import AIAdvisor from "@/pages/AIAdvisor";

function Private({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return (
    <PlantProvider>
      <Shell>{children}</Shell>
    </PlantProvider>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Private><CommandCentre /></Private>} />
          <Route path="/furnace" element={<Private><Furnace /></Private>} />
          <Route path="/charge" element={<Private><Charge /></Private>} />
          <Route path="/operations" element={<Private><Operations /></Private>} />
          <Route path="/air" element={<Private><Air /></Private>} />
          <Route path="/utilities" element={<Private><Utilities /></Private>} />
          <Route path="/yield" element={<Private><YieldScreen /></Private>} />
          <Route path="/ai-advisor" element={<Private><AIAdvisor /></Private>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
